import Toast from "react-native-root-toast";
import { toast as webToast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import {isWEB} from "./helpers/getPlatformType";

let toast;

export const hideToast = () => {
    hideToastWeb();
    hideToastNative();
};

export const showToastMessage = (message, duration = 60000) => {
    hideToast();

    showToastNative(message, duration);
    showToastWeb(message, duration);
};

const hideToastWeb = () => {
    if (isWEB()) {
        webToast.dismiss();
    }
};

const hideToastNative = () => {
    if (!isWEB()) {
        if (typeof toast === 'undefined' || toast === null) {
            return;
        }

        Toast.hide(toast);
    }
};

const showToastWeb = (message, duration = 60000) => {
    if (isWEB()) {
        webToast(message, {
            autoClose: duration,
            position: "top-right",
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        })
    }
}

const showToastNative = (message, duration = 60000) => {
    if (!isWEB()) {
        toast = Toast.show(message, {
            duration: duration,
            position: -40,
            shadow: true,
            animation: true,
            hideOnPress: true,
            delay: 0,
            onShow: () => {},
            onShown: () => {},
            onHide: () => {},
            onHidden: () => {}
        });
    }
}

export const WebToastContainer = () => (isWEB() ? <ToastContainer /> : null);